import { LOGIN_URL } from '../../../../../containers/LoginPage/constants'

export function getURLForLoggedOutPlayForReal(isLoginAndPlayPossible: boolean, realPlayUrl: string) {
  return isLoginAndPlayPossible ? `${LOGIN_URL}?redirect=${realPlayUrl}` : `${LOGIN_URL}`
}
